import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthentificationService } from './authentification.service';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ParametersServiceMyFactory } from '../general/parameters-service-my-factory.service';
import { ThemeService } from '../general/theme.service';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {

  static URL = environment.urlServer;

	constructor(private http: HttpClient, private authentificationService: AuthentificationService, private myFactoryParams: ParametersServiceMyFactory,
    private themeService: ThemeService
  ) {}

  public getBackOffice_ParametresPersonalisations(): Observable<any> {
    const headers = this.authentificationService.headers;
    
    return this.http
      .get(ParametersService.URL + 'ParametresPersonnalisations/', { headers: headers, observe: 'response' })  
      .pipe(map((response: HttpResponse<any>) => {
          console.warn(response.body);
          if(response.body) {
            this.myFactoryParams.customerAccountParameters = response.body;     
            this.themeService.setAllTheme();
          }
          return response.body;
        })
      );
  }

  public getManyCurrency(): Observable<any> {
    const headers = this.authentificationService.headers;
    
    return this.http
      .get(ParametersServiceMyFactory.URL + 'ParametresPersonnalisations/Devise', { headers: headers, observe: 'response' })  
      .pipe(map((response: HttpResponse<any>) => {
        this.myFactoryParams.listCurrency = response.body;
          return response.body;
        })
      );
  }
}
